module.exports = __webpack_public_path__ + "img/library_books.7e044234.svg";